
import request from '@/request'
const part_url = '/train/web/enterprise/';

function getEnterpriseInfo() {
    let url = part_url + "getEnterpriseInfo";
    return request.get(url, {})
}
function register(param) {
    let url = part_url + "register";
    return request.post(url, {}, param)
}
// 发送的是这个请求 有问题吗？我看看啊
function specialistRegister(param) {
    let url = part_url + "specialistRegister";
    return request.post(url,{},param)
}
export default {
    getEnterpriseInfo,
    register,
    specialistRegister
}


// WEBPACK FOOTER //
// ./src/api/enterprise.js